import { useRef } from 'react';
import { MarkerDefinition } from './GoogleMap';
import { useInitMap } from './hooks/use-init-map';
import { useInitMarkers } from './hooks/use-init-markers';

interface MapContainerProps {
  center: { lng: number; lat: number };
  maxZoom: number;
  markerDefinitions: MarkerDefinition[];
}

export function MapContainer({
  center,
  maxZoom,
  markerDefinitions,
}: MapContainerProps) {
  const ref = useRef<HTMLDivElement>(null);

  const map = useInitMap({ center, maxZoom, ref });

  useInitMarkers({
    markerDefinitions: [
      ...markerDefinitions.filter(({ color }) => color === 'gray'),
      ...markerDefinitions.filter(({ color }) => color === 'red'),
    ],
    map,
  });

  return <div ref={ref} id="map" style={{ height: '500px' }} />;
}
